export const backendUrl = {
  baseUrl: process.env.REACT_APP_BASE_URL,
};
export const frontendUrl = {
  baseUrl: process.env.REACT_APP_FE_BASE_URL,
};
export const ssoConfig = {
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  googleClientSecretKey: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
  githubClientId: process.env.REACT_APP_GITHUB_CLIENT_ID,
  githubClientSecretKey: process.env.REACT_APP_GITHUB_CLIENT_SECRET,
};
